import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createRoot } from 'react-dom/client'
import App from './components/App'
import { preloadYearsSeed, preloadMakesSeed } from './services/SeedPrefetchService'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
})

preloadYearsSeed()
preloadMakesSeed()

const root = createRoot(document.getElementById('root-videos'))

root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </React.StrictMode>
)
